const { documentReady, windowLoaded } = require('@grpn/document-states');
require('src/frontend/helper/general/m_googleTagManager');
const backToTopButton = require('modules/gig_body/components/back2top/frontend/main');
const doubleClick = require('modules/doubleclick/frontend/doubleclick');
const {
  checkRightToForget,
} = require('modules/right_to_forget_gdpr/frontend/rightToForgetGdpr');
const verifyUserCookies = require('src/frontend/helper/general/m_verifyUserCookies');
const {
  initGdprCookieBanners,
} = require('modules/cookie_banner_gdpr/frontend/main');

const { loadBoldChat } = require('src/frontend/core/loadBoldChat');

require('grpn-gig-components/lib/components/a11y/a11y');
const { checkAdBlocker } = require('src/frontend/helper/adBlockerCheck');
const { hideMerchandising } = require('src/frontend/helper/MerchandisingDisabler');

documentReady.then(() => {
  document.body.classList.remove('no-js');
  hideMerchandising();
  checkAdBlocker();
});

windowLoaded.then(() => {
  initGdprCookieBanners();
  doubleClick.init();

  checkRightToForget();

  Groupon.Utils.lazyLoadImages('.lazy-wl', { threshold: 200 });

  verifyUserCookies();

  new backToTopButton();

  if (window.Groupon.boldChat) {
    loadBoldChat(window.Groupon.boldChat);
  }
});

//Do not remove or hash on dynamic imports will not update
export default () => {};
